// ── Assets-only image workshop (?mode=assets) ───────────────────
//
// 阶段 B 兼容桥：外部链接 ?mode=assets 已由 routes/pages.mjs 301 到
// /image-suite.html?fromLegacy=1&projectId=<id>，不会再进入 listing.html。
//
// 但如果用户通过浏览器历史 / 书签绕过了 301（例如直接在 listing.html 上
// 切 ?mode=assets），这里做一个 client-side 重定向到新套图页，而不是
// 渲染旧的 assets-workshop。
//
// assets-workshop.js 本体在阶段 B 保留不删；彻底清理留到 B3 单独 PR。

import { showToast } from './toast.js';

/** 顶栏切换按钮：已迁移，指向新套图页 */
export function syncWorkshopModeToggle(assetsMode) {
  const btn = document.getElementById('workshop-mode-toggle');
  if (!btn) return;
  if (assetsMode) {
    btn.href = '/';
    btn.textContent = '返回工作台';
    btn.title = '返回工作台';
  } else {
    btn.href = '/image-suite.html';
    btn.textContent = '套图生成';
    btn.title = '打开套图生成页面';
  }
}

/**
 * 阶段 B 兼容桥：不再渲染旧 assets 工坊，而是重定向到新套图页。
 * routes/pages.mjs 会在服务端 301 处理 ?mode=assets，这里是
 * 客户端 fallback（万一绕过了服务端重定向）。
 */
export function initAssetsWorkshop() {
  // 客户端 fallback 重定向到新套图页
  const urlParams = new URLSearchParams(window.location.search);
  const projectId = urlParams.get('projectId');
  const params = new URLSearchParams({ fromLegacy: '1' });
  if (projectId) params.set('projectId', projectId);
  showToast('正在跳转到新套图页面…', { id: 'assets-toast', duration: 2000 });
  setTimeout(() => {
    window.location.href = `/image-suite.html?${params.toString()}`;
  }, 500);
}

export function isAssetsMode() {
  return new URLSearchParams(window.location.search).get('mode') === 'assets';
}
